<template lang="pug">
div
  .sgbox.cq9.aaa
    .gbox
      #preloader(v-if="gameLaunching")
        #loader
      .ggl
        a(href="javascript:void(0)" @click='launchGame')
          img(src='assets/img/product-thumb/slot/cq9.jpg')
          span CQ9 Gaming
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      offList:[],
      mobileDevice: false
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "my":
          return "en"
        case "zh":
          return "zh-CN"
        default :
          return "en"
      }
    }
  },
  mounted(){
    // window.scroll(0,0)
    this.getMobile()
    // this.getProviderGameOfflist()
  },
  methods:{
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "CQ9"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              // this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				// this.getGameList()
			}
    },
    // getGameList(){
    //   var vm = this
    //   this.pageLoading = true
		// 	var url = config.getCq9GameList()
    //   this.$http.get(url).then(
    //     successResponse => {
    //       if(successResponse){
    //         if (typeof successResponse.data.status == "string") {
    //           this.feedback.success = successResponse.status == "200";
    //         } else {
    //           this.feedback.success = successResponse.status == 200;
    //         }
    //         this.feedback.status = successResponse.status;
    //         if (this.feedback.success == true) {
    //           this.gameList = successResponse.data.game_list
    //           this.gameList.forEach(function(item){
    //             item["rtp"] = parseFloat((Math.random() * (vm.max - vm.min) + vm.min).toFixed(vm.precision) * 1).toFixed(2);
    //           })
    //           let updateList = [].concat(
    //             this.gameList.filter(obj1 => this.offList.every(obj2 => obj1.KeyName !== obj2.game_id)),
    //             this.offList.filter(obj2 => this.gameList.every(obj1 => obj2.game_id !== obj1.KeyName))
    //           )
    //           this.items = _.chunk(updateList, 30);
    //           this.listToDisplay = this.items[0]
    //           this.pageLoading = false
    //         } else {
    //           this.pageLoading = false
    //         }
    //       }else{
    //         this.pageLoading = false
    //       }
    //     },
    //     errorResponse => {
    //       this.pageLoading = false
    //       console.log(errorResponse)
    //     }
    //   );
    // },
    launchGame(){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        // let game_code = game
        let lang_code = this.getLanguage
        // let platform = this.mobileDevice ? 'MOBILE' : 'WEB'
        this.$store
          .dispatch("user/launchCq9", { player_id, auth_token, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.lobby, "_blank")
                vm.gameLaunching = false
							}) 
            } else {     
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    // vm.$router.push("/slot").catch(error =>{})
                    vm.$store.dispatch("user/setSlotSelected", 0)
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    },
  }
}
</script>